import React from 'react'
import { Route } from 'react-router-dom'
import FoldersView from 'components/FoldersView'

const FoldersRoutes = ({ match }) => (
  <>
    <Route path={match.path} component={FoldersView} />
  </>
)

export default FoldersRoutes
